import React from 'react'
import { useNavigate } from 'react-router'

import { EmptyState } from 'components/empty-state/EmptyState'

const TITLE = "This project isn't available right now"
const DESCRIPTION =
  'It may have been archived or may still be processing. If this is unexpected, contact support.'
const ACTION_LABEL = 'Return Home'

export const UnavailableProject: React.FC = () => {
  const navigate = useNavigate()

  return (
    <EmptyState
      title={TITLE}
      description={DESCRIPTION}
      textWidth="300px"
      actions={[
        {
          label: ACTION_LABEL,
          onClick: () => navigate('/'),
        },
      ]}
      fullHeight="viewport"
    />
  )
}
